/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type Locale } from '@/types/i18n';
import { type ParsedUrlQuery } from 'querystring';
import { type LocationsParams } from '../interface/types';
import { locationsPrefix } from '../constants/locationsPrefix';

const normalizeParam = (value: string | string[] | undefined) =>
  (Array.isArray(value) ? value[0] : value)?.replace(/\.html$/, '');

export const getLocationsParams = (locale: Locale, query: ParsedUrlQuery): LocationsParams => {
  const locationsHome = locationsPrefix[locale];
  const { state, city, storeAddress } = query;

  return {
    locationsHome,
    state: normalizeParam(state),
    city: normalizeParam(city),
    address: normalizeParam(storeAddress),
  };
};
